__turbopack_context__.v({
  "card": "no-results-card-module-scss-module__vZgbpq__card",
  "card__message": "no-results-card-module-scss-module__vZgbpq__card__message",
  "card__message-title": "no-results-card-module-scss-module__vZgbpq__card__message-title",
});
